import { render, staticRenderFns } from "./ItemPlanner.vue?vue&type=template&id=09eb52aa&scoped=true&"
import script from "./ItemPlanner.vue?vue&type=script&lang=js&"
export * from "./ItemPlanner.vue?vue&type=script&lang=js&"
import style0 from "./ItemPlanner.vue?vue&type=style&index=0&id=09eb52aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eb52aa",
  null
  
)


    import installComponents from "!C:/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BForm} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BForm})
    

export default component.exports